import styled from 'styled-components';

export const OnboardingCongratulationsPageStyled = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    background-image: url('/assets/onboarding/congratulations-bg.svg');
    background-repeat: no-repeat;
    background-position-y: 0;
    background-position-x: center;
    background-size: 100%;
    background-color: var(--color-surface);
    @media(max-height: 600px) {
        background-position-y: -50px;
        
        h1 {
            font-size: 24px;
        }
    }
`;

export const OnboardingCongratulationsContainerStyled = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin: 0 auto;
    width: 100%;
    max-width: 500px;
    justify-content: center;
    height: 100%;
    flex-grow: 1;
    
    em {
        font-style: normal;
        color: var(--color-yellow);
    }
`;

export const OnboardingCongratulationsContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    @media(max-height: 700px) {
        margin-top: 0;
    }
`;

export const OnboardingRepeatedCongratulationsContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
`;
